<template>
  <div
    class=""
    ref="dialog"
    id="dialog"
    tabindex="-1"
    role="dialog"
    aria-labelledby="Modal"
    style="display: block"
  >
    <div class="modal-dialog modal-xl" role="document">
      <form @submit.prevent="login">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h4 class="modal-title">{{ title ? title : "Login" }}</h4>
              <p>{{ description }}</p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="cancel()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body form">
            <div v-if="errorMsg" class="card text-white bg-danger mb-3 w-100">
              <div class="card-header">Error</div>
              <div class="card-body">
                <p v-if="errorMsg === 'USER_LOGIN_LOCKED'" class="card-text">User account locked until: {{lockedUntil}}</p>
                <p v-else class="card-text">Login failed ({{errorMsg}})</p>
              </div>
            </div>
            <div class="form-group">
              <label for="email" class="sr-only">{{ tp.email }}</label>
              <div class="input-group">
                <span class="input-group-addon"
                  ><span class="glyphicon glyphicon-user"></span
                ></span>
                <input
                  v-model="username"
                  type="text"
                  id="email"
                  class="form-control"
                  placeholder="email"
                  aria-describedby="email"
                  v-on:keyup="clearError"
                  v-on:focusin="clearError"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="password" class="sr-only">{{ tp.password }}</label>
              <div class="input-group">
                <span class="input-group-addon"
                  ><span class="glyphicon glyphicon-lock"></span
                ></span>
                <input
                  v-model="password"
                  type="password"
                  id="password"
                  class="form-control"
                  placeholder="password"
                  aria-describedby="password"
                  v-on:keyup="clearError"
                  v-on:focusin="clearError"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="domainAccountName" class="sr-only">{{
                tp.domainAccount
              }}</label>
              <div class="input-group">
                <span class="input-group-addon"
                  ><span class="glyphicon glyphicon-asterisk"></span
                ></span>
                <input
                  v-model="domainAccountName"
                  type="text"
                  id="domainAccountName"
                  class="form-control"
                  placeholder="Domain Account"
                  aria-describedby="domainAccountName"
                  v-on:keyup="clearError"
                  v-on:focusin="clearError"
                />
              </div>
            </div>
            <div class="form-group" v-if="showDomainAccountList">
              <fieldset class="radiogroup">
                <div
                  v-for="(domainAccount, index) in domainAccountList"
                  :key="index"
                >
                  <input
                    type="radio"
                    v-model="domainAccountName"
                    :id="'domainAccount' + index"
                    :value="domainAccount"
                  /><label :for="'domainAccount' + index"
                    >&nbsp;&nbsp;{{ domainAccount }}</label
                  >
                </div>
              </fieldset>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-outline-dark"
              data-dismiss="modal"
              @click="login()"
            >
              <i class="fas fa-sign-in-alt"></i> Login
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { stringCompare, validEmail, getCookie } from "@/common/utils";
import { TT_URL } from "@/common/constants";
import axios from "axios";

export default {
  name: "login",
  props: {
    tp: { type: Object, required: false },
    title: { type: String, required: false },
    description: { type: String, required: true },
    showDomainAccountList: { type: Boolean, required: true },
    tibPath: { type: String, required: true },
    tibName: { type: String, required: true }
  },
  data: function() {
    return {
      username: "",
      password: "",
      domainAccountName: "",
      domainAccountList: [],
      errorMsg : null,
      lockedUntil: null
    };
  },
  watch: {
    // eslint-disable-next-line
    username: function(val) {
      this.updateDomainAccountsFromEmail();
    }
  },
  mounted() {
    let url = new URL(window.location.href);
    this.domainAccountName = url.searchParams.get("domainAccount");
    var emails = url.searchParams.get("emails");

    if (!this.domainAccountName) {
      var domainNameFromCookie = getCookie("lastdomainname");
      var accountNameFromCookie = getCookie("lastaccountname");

      if (domainNameFromCookie && accountNameFromCookie) {
        this.domainAccountName =
          accountNameFromCookie + "##" + domainNameFromCookie;
      }
    }

    if (emails) {
      /* extract first email from comma separated list */
      this.username = emails.split(",")[0];
    }

    if (!this.username) {
      var usernameFromCookie = getCookie("lastusername");

      if (usernameFromCookie) {
        usernameFromCookie = usernameFromCookie.replace('"', "");
        usernameFromCookie = usernameFromCookie.replace('"', "");
        this.username = usernameFromCookie;
      }
    }
  },
  methods: {
    setLoggedIn(on) {
      console.info("setLoggedIn:" + on);
      this.$emit("setloggedin", on);
    },
    login() {
      console.info("login()");
      let self = this;

      if (typeof this.tibName === "undefined" || this.tibName === "") {
        axios
          .post(TT_URL + "/api/tibtix.com/login", {
            username: this.username,
            password: this.password,
            domainAccountName: this.domainAccountName
          })
          .then(function(response) {
            if (!response.data.loggedIn) {
              self.errorMsg = response.data.errorCode;
              self.lockedUntil = new Date(response.data.lockedUntil);
            } else {
              self.setLoggedIn(response.data.loggedIn);
              self.clearError();
            }
          })
          .catch(function(error) {
            self.errorMsg = error;
            //self.$emit("error", "An error has occurred." + "\n" + error);
          });
      } else {
        axios
          .post(TT_URL + "/view/loginAndAccessTib", {
            loginCredentials: {
              username: this.username,
              password: this.password,
              domainAccountName: this.domainAccountName
            },
            path: this.tibPath,
            name: this.tibName
          })
          .then(function(response) {
            if (!response.data) {
              self.errorMsg = "LOGIN_FAILED";
            } else {
              self.clearError();
              self.$emit("tib", response.data);
            }
          })
          .catch(function(error) {
            self.errorMsg = error;
            //self.$emit("error", "An error has occurred." + "\n" + error);
          });
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    clearError() {
        this.errorMsg = null;
        this.lockedUntil = null;
    },
    updateDomainAccountsFromEmail() {
      var email = this.username;
      var self = this;

      if (!validEmail(email)) {
        return;
      }

      axios
        .post(TT_URL + "/api/tib/getDomainAccountsByEmail", {
          email: this.username
        })
        .then(
          response =>
            (this.domainAccountList = response.data.sort(stringCompare))
        )
        .catch(function() {
          self.domainAccountList = [];
        });
    }
  }
};
</script>
